<template>
  <v-navigation-drawer
    app
    :mini-variant.sync="showMiniBarMenu"
    class="white"
    :width="300"
    v-bind="[$attrs, $props]"
    v-model="drawer"
    style="z-index: 9;"
  >
    <v-col cols="12" class="d-flex px-0 justify-center pb-9 pt-4 no-print">
      <img
        v-if="!showMiniBarMenu"
        src="@/assets/logo_texto_preto.png"
        alt="Logo LSP"
        width="45%"
        class="no-print"
      />
      <img
        v-if="showMiniBarMenu"
        src="@/assets/logo-lockton-pequeno.png"
        alt="Logo LSP"
        width="45%"
        class="no-print"
      />
    </v-col>
    <v-list dense class="pb-6 no-print">
      <v-list-item :key="key" v-for="(item, key) of enableModules" class="px-0">
        <v-row>
          <v-col cols="12" :class="classSelectedItem(item) + ' px-0'">
            <v-tooltip v-if="showMiniBarMenu" bottom>
              <template v-slot:activator="{ on }">
                <SidebarItem
                  :textButton="item.name"
                  :mini="showMiniBarMenu"
                  :customIcon="selectedIcon(item)"
                  @click="updateSelectedItem(item)"
                  :class="backgroundSelectedItem(item)"
                  :has-children="hasListChildren(item)"
                  :selected="isSeletecItem(item)"
                  v-on="on"
                />
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
            <SidebarItem
              :textButton="item.name"
              :mini="showMiniBarMenu"
              :customIcon="selectedIcon(item)"
              @click="updateSelectedItem(item)"
              :class="backgroundSelectedItem(item)"
              :has-children="hasListChildren(item)"
              :selected="isSeletecItem(item)"
              v-if="!showMiniBarMenu"
            />
          </v-col>
          <v-col cols="12">
            <v-list dense v-if="hasListChildren(item) && isSeletecItem(item)">
              <v-list-item
                :key="key"
                v-for="(element, key) of enableRoutes(item.listChildren)"
                class="px-0 ml-7"
              >
                <SidebarItem
                  :textButton="element.name"
                  :mini="mini"
                  :to="{ name: element.moduleName }"
                  :class="
                    backgroundSelectedChildren(element) +
                      ' pl-0 ' +
                      classSelectedChildren(element)
                  "
                  :selected="$route.name.includes(element.moduleName)"
                  :children="$route.name.includes(element.moduleName)"
                  :module="false"
                />
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <v-col cols="12" :class="classMiniSidebar + ' my-5 d-none d-lg-flex'">
        <BaseButton
          class="white gray--text justify-start no-print"
          @click="updateMiniSidebar()"
          width="100%"
        >
          <img src="@/assets/ic_menu_hidemenu.svg" class="pr-6" />
          Esconder o menu
        </BaseButton>
      </v-col>
    </template>
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      selected: null,
      generalItems: [
        {
          name: "Cadastro",
          img: require("@/assets/ic_cadastro.svg"),
          imgSelected: require("@/assets/ic_cadastro_azul.svg"),
          moduleName: "cadastro",
          permissionModule: "cadastro",
          listChildren: [
            {
              name: "Grupo Econômico",
              moduleName: "economic_group",
              permissionRoute: "visualizar_grupo_economico"
            },
            {
              name: "Seguradoras",
              moduleName: "insurance_company",
              permissionRoute: "visualizar_seguradora"
            },
            {
              name: "Corretoras",
              moduleName: "brokers",
              permissionRoute: "visualizar_seguradora"
            },
            {
              name: "Grupos Modalidades",
              moduleName: "modality",
              permissionRoute: "visualizar_modalidade"
            },
            {
              name: "Tribunais",
              moduleName: "court",
              permissionRoute: "visualizar_tribunal"
            },
            {
              name: "Motivos de cancelamentos",
              moduleName: "reason_cancel",
              permissionRoute: "visualizar_motivo_cancelamento"
            },
            {
              name: "Escritórios",
              moduleName: "office",
              permissionRoute: "visualizar_escritorio"
            }
          ]
        },
        {
          name: "Cotações",
          img: require("@/assets/ic_cotações.svg"),
          imgSelected: require("@/assets/ic_cotações_azul.svg"),
          moduleName: "quotation",
          permissionModule: "cotacao",
          listChildren: []
        },
        {
          name: "Propostas",
          img: require("@/assets/ic_apolices.svg"),
          imgSelected: require("@/assets/ic_apolices_azul.svg"),
          moduleName: "proposal",
          permissionModule: "apolice",
          listChildren: []
        },
        {
          name: "Apólices",
          img: require("@/assets/ic_apolices.svg"),
          imgSelected: require("@/assets/ic_apolices_azul.svg"),
          moduleName: "policy",
          permissionModule: "apolice",
          listChildren: []
        },
        {
          name: "Endossos",
          img: require("@/assets/ic_apolices.svg"),
          imgSelected: require("@/assets/ic_apolices_azul.svg"),
          moduleName: "request endorsement",
          permissionModule: "apolice",
          listChildren: []
        },
        {
          name: "Carteira",
          img: require("@/assets/ic_carteira.svg"),
          imgSelected: require("@/assets/ic_carteira_azul.svg"),
          moduleName: "login",
          permissionModule: "carteira",
          listChildren: []
        },
        {
          name: "Dashboards",
          img: require("@/assets/dashboard_white.svg"),
          imgSelected: require("@/assets/dashboard_blue.svg"),
          moduleName: "dashboard",
          permissionModule: "dashboard",
          listChildren: []
        },
        {
          name: "Importação do Legado",
          img: require("@/assets/ic_carteira.svg"),
          imgSelected: require("@/assets/ic_carteira_azul.svg"),
          moduleName: "legacy_importation",
          permissionModule: "importacao_legado",
          listChildren: []
        },
        {
          name: "Configurações",
          img: require("@/assets/ic_gear.svg"),
          imgSelected: require("@/assets/ic_gear_azul.svg"),
          moduleName: "configuracao",
          permissionModule: "configuracao",
          listChildren: [
            {
              name: "Perfil",
              moduleName: "profile",
              permissionRoute: "visualizar_perfil"
            },
            {
              name: "Usuário",
              moduleName: "user",
              permissionRoute: "visualizar_usuario"
            }
          ]
        }
      ],
      drawer: null
    };
  },
  mounted() {
    let currentItem;
    // Preciso buscar qual módulo está sendo visualizado
    // independente se é a rota é do filho ou o próprio módulo
    this.generalItems.forEach(item => {
      if (this.$route.name.includes(item.moduleName)) currentItem = item;
      item.listChildren.forEach(element => {
        if (this.$route.name.includes(element.moduleName)) currentItem = item;
      });
    });

    this.selected = currentItem;
  },
  computed: {
    ...mapState(["userPermissions", "showMiniBarMenu"]),
    ...mapState("me", ["userAreaIsAgro"]),
    classMiniSidebar() {
      return this.showMiniBarMenu ? "px-1 " : "px-6 ";
    },
    enableModules() {
      if (this.userAreaIsAgro) {
        delete this.generalItems[4];
      }
      return this.generalItems.filter(
        x =>
          this.userPermissions.modulos.findIndex(
            el => el.id === x.permissionModule
          ) > -1
      );
    }
  },
  methods: {
    ...mapActions(["setShowMiniBarMenu"]),
    enableRoutes(item) {
      return item.filter(
        x =>
          this.userPermissions.acoes.findIndex(
            el => el.id === x.permissionRoute
          ) > -1
      );
    },
    updateMiniSidebar() {
      this.setShowMiniBarMenu(!this.showMiniBarMenu);
    },
    classSelectedChildren(item) {
      return this.$route.name.includes(item.moduleName) ? "selected-item" : "";
    },
    classSelectedItem(item) {
      return this.isSeletecItem(item) ||
        this.$route.name.includes(item.moduleName)
        ? "selected-item"
        : "";
    },
    isSeletecItem(item) {
      return this.selected == item;
    },
    updateSelectedItem(item) {
      if (item.listChildren.length > 0 && this.showMiniBarMenu == true) {
        this.updateMiniSidebar();
      }
      this.selected = this.selected == item ? null : item;
      if (!this.hasListChildren(item))
        this.$router.push({ name: item.moduleName });
    },
    hasListChildren(item) {
      return item.listChildren.length > 0;
    },
    backgroundSelectedItem(item) {
      return this.isSeletecItem(item)
        ? "white blue--text px-5"
        : "white gray--text px-6";
    },
    backgroundSelectedChildren(item) {
      return this.$route.name.includes(item.moduleName)
        ? "white blue--text px-5"
        : "white gray--text px-6";
    },
    selectedIcon(item) {
      return this.$route.name.includes(item.moduleName)
        ? item.imgSelected
        : item.img;
    }
  }
};
</script>
<style lang="sass" scoped>
.selected-item
  border-left: 5px solid #059EE4

@media print
  .no-print
    display: none
</style>
